import React from 'react';
import './Loader.scss'; 
import { Spinner } from 'react-bootstrap';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <Spinner animation="border" role="status" className="loader-spinner">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;
